<div class="tsl-confirm" [formGroup]="paramGroup">
    <div class="prompt-header">
        <h3
            class="prompt-header-title"
            i18n="@@a40af622381b9357d0e6100b51e9e3d03bddc375"
            t="a40af622381b9357d0e6100b51e9e3d03bddc375"
            >Associate Part
        </h3>
    </div>

    <div class="prompt-header">
        <h4 class="prompt" i18n="@@7409935768692047752" t="7409935768692047752"
            >If you are unable to search for the Part Number(s), please contact your GSM or supplierportal@tesla.com with details
            of your supplier code and Part Number(s)
        </h4>
    </div>

    <div class="prompt-content">
        <tsl-form-field fxFlex="90">
            <tsl-label
                for="partNumber"
                i18n="@@123981d39030a859324d7229eac1c4d07f060e27"
                t="123981d39030a859324d7229eac1c4d07f060e27"
                >Part Number</tsl-label
            >
            <tsl-multiselect
                id="partNumber"
                required
                fullWidth
                maxlength="50"
                formControlName="partNumber"
                [settings]="searchSettings"
                (searchChange)="onSearch($event)"
                (selectionChange)="onSelectPart($event)"
                [data]="formattedParts"
                multiple
            >
            </tsl-multiselect>
        </tsl-form-field>
    </div>

    <div fxLayoutAlign="end center" class="prompt-buttons tsl-content-buttons">
        <button tsl-button filled color="black" size="small" (click)="onClose()" i18n="@@Cancel" t="Cancel"
            >Cancel</button
        >
        <button
            tsl-button
            filled
            color="blue"
            size="small"
            [disabled]="paramGroup.invalid"
            (click)="onSave()"
            i18n="@@f6755cff4957d5c3c89bafce5651f1b6fa2b1fd9"
            t="f6755cff4957d5c3c89bafce5651f1b6fa2b1fd9"
            >Add</button
        >
    </div>
</div>
